export function formatLaneName(lane: { direction: string; name: string }) {
  return `${lane.direction} Gate Access`;
}
